import {
  Box,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  HStack,
  VStack,
} from '@chakra-ui/react'
import NextLink from 'next/link'

export const AuthorInfo = ({ author }: { author: any }) => {
  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <Box borderRadius="full" width="36px" height="36px">
          <Image
            width="100%"
            height="100%"
            objectFit="cover"
            borderRadius="full"
            src={author?.profile_image}
            alt={author?.name}
          />
        </Box>
      </PopoverTrigger>
      <PopoverContent
        className="author-card"
        boxShadow="0 12px 26px rgba(39,44,49,.08), 1px 3px 8px rgba(39,44,49,.06)"
        borderRadius="3px"
      >
        <PopoverArrow />
        <PopoverBody>
          <HStack spacing="0" alignItems="center">
            <Image
              className="author-profile-image"
              src={author?.profile_image}
              alt={author?.name}
            />
            <VStack spacing="0" className="author-info" alignItems="flex-start">
              <Box as="h2">{author?.name}</Box>
              <Box as="p">{author?.bio}</Box>
              <Box as="p" fontSize="14px !important">
                Read{' '}
                <NextLink href={`/education/author/${author?.slug}`}>
                  more posts
                </NextLink>{' '}
                by this author
              </Box>
            </VStack>
          </HStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
